/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi-container/~/lodash/_getValue.js
// module id = ./node_modules/victory-voronoi-container/node_modules/lodash/_getValue.js
// module chunks = 1